import { useMemo } from 'react';
import cns from 'classnames';
import { format } from 'date-fns';
import { ParseKeys } from 'i18next';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useDialog } from '@zep/dialog';
import { Chip, IconContainer } from '@zep/ui';
import { StoreCategoryNumber, StoreReviewState } from '../../../consts';
import { StoreItem } from '../../../types';
import { QuestionmarkSmallCircleIcon } from '../../icons';
import S from './ManageAsset.module.scss';
const ManageAssetRow = ({
  asset
}: AssetControlRowProps) => {
  const dialog = useDialog();
  const {
    t
  } = useTranslation(['manage']);
  const renderReviewState = useMemo(() => {
    const type = asset.category === StoreCategoryNumber.map || asset.category === StoreCategoryNumber.object ? 'asset' : 'app';
    switch (asset.state) {
      case StoreReviewState.required:
        return <>
            <Chip variant="default">{t('manage:myAsset.state.required')}</Chip>
            <span>{t('manage:myAsset.requiredNotify.requiredDate')}</span>
          </>;
      case StoreReviewState.completed:
      case StoreReviewState.official:
        return <Chip variant="primary">{t('manage:myAsset.state.completed')}</Chip>;
      case StoreReviewState.rejected:
        return <>
            <Chip variant="alert">{t('manage:myAsset.state.rejected')}</Chip>
            <IconContainer onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            void dialog.alert({
              title: t('manage:myAsset.rejectNotify.title'),
              content: t(`manage:myAsset.rejectNotify.${type}Reason${asset.stateReason || (type === 'asset' ? 10 : 16)}` as ParseKeys<'manage'>)
            });
          }}>
              <QuestionmarkSmallCircleIcon width={20} height={20} />
            </IconContainer>
          </>;
      case StoreReviewState.unofficial:
        return <Chip variant="primary">
            {t('manage:myAsset.state.unofficial', '비공식')}
          </Chip>;
      default:
        return <></>;
    }
  }, [asset.category, asset.state, asset.stateReason, dialog, t]);
  return <Link href={`/store/details?id=${asset.hashId}`} target={'_blank'} data-sentry-element="Link" data-sentry-component="ManageAssetRow" data-sentry-source-file="ManageAssetRow.tsx">
      <div className={S.row_wrapper}>
        <div className={S.thumbnail_wrapper}>
          <img className={cns({
          [S.app_icon]: asset.category === StoreCategoryNumber.app || asset.category === StoreCategoryNumber.game
        })} src={asset.finalImageUrl} alt="thumbnail" />
        </div>
        <div className={S.row_content}>
          <h2 className={S.asset_title}>{asset.name}</h2>
          <h3 className={S.asset_summary}>
            {`${t('manage:myAsset.item.createdAt')} : ${format(new Date(asset.createdAt), 'yyyy.MM.dd')}`}
          </h3>
          <h4 className={S.asset_information}>{renderReviewState}</h4>
        </div>
      </div>
    </Link>;
};
export default ManageAssetRow;
type AssetControlRowProps = {
  asset: StoreItem;
};